import React, { Suspense } from 'react';

import { useLocalStorage } from '@uidotdev/usehooks';
import { Outlet } from 'react-router-dom';

import { PlatformProvider } from '@platform/core/platform-provider';

import { FeatureFlagsDialog } from '@packages/platform/feature-flags';

const FeatureFlag = ({ children }: React.PropsWithChildren) => {
  const [flagManager] = useLocalStorage('FLAG_MANAGER', undefined);
  const showFlagManager = flagManager || import.meta.env.DEV;

  return (
    <>
      {showFlagManager && <FeatureFlagsDialog />}
      {children}
    </>
  );
};

export const RootElement = () => (
  <React.StrictMode>
    <Suspense>
      <PlatformProvider>
        <FeatureFlag>
          <Outlet />
        </FeatureFlag>
      </PlatformProvider>
    </Suspense>
  </React.StrictMode>
);
